import TickerGlobalResultCard from "./TickerGlobalResultCard";
import TickerBaseballResultCard from "./TickerBaseballResultCard";
import TickerFootballResultCard from "./TickerFootballResultCard";

/** Enruta la tarjeta de resultados según el deporte de la liga (FOOT / BASE / AMFO). */
export default function TickerResultCard({ result, league, sportCode = "FOOT" }) {
  const sport = String(sportCode || "").toUpperCase();

  if (sport === "BASE") {
    return <TickerBaseballResultCard result={result} league={league} />;
  }

  if (sport === "AMFO") {
    return <TickerFootballResultCard result={result} league={league} />;
  }

  return <TickerGlobalResultCard result={result} league={league} sportCode="FOOT" />;
}
